import React, { Component } from 'react';
import { Select } from '../../inputs';
import './PlayerMeta.css';

class PlayerMeta extends Component {
	constructor(props) {
		super(props);
		this.state = {
			goals: {
				0: {
					name: 0,
					id: 0,
				},
				1: {
					name: 1,
					id: 1,
				},
				2: {
					name: 2,
					id: 2,
				},
				3: {
					name: 3,
					id: 3,
				},
				4: {
					name: 4,
					id: 4,
				},
				5: {
					name: 5,
					id: 5,
				},
			},
			goalsById: [0, 1, 2, 3, 4, 5],
			cards: {
				0: {
					name: 'None',
					id: 0,
				},
				1: {
					name: 'Yellow',
					id: 1,
				},
				2: {
					id: 2,
					name: '2 Yellow',
				},
				3: {
					id: 3,
					name: 'Red',
				},
			},
			cardsById: [0, 1, 2, 3],
		};
	}

	onGoalChange = val => {
		if (typeof val === 'undefined' || val === '') {
			val = '0';
		}
		this.props.onGoalChange(val, this.props.playerReport);
	};
	onCardChange = val => {
		if (typeof val === 'undefined' || val === '') {
			val = '0';
		}
		this.props.onCardChange(parseInt(val, 10), this.props.playerReport);
	};

	onPositionChange = val => {
		this.props.onPositionChange(val);
	};

	_getPositionId() {
		let v = null;
		this.props.positions.map((val, i) => {
			if (this.props.playerReport.onChange.position === val) {
				v = i;
				return i;
			}
		});
		return v;
	}

	render() {
		return (
			<div className="flexContainerCol player-meta">
				<div className="flexContainerRow">
					<span className="meta-item firname">{this.props.player.firstName} </span>
					<span className="meta-item-large surname">{this.props.player.surname}</span>
				</div>
				<div className="flexContainerRow">
					<div className="squad-number">{this.props.player.squadNumber} </div>
				</div>

				{!this.props.playerReport.readOnly ? (
					<div className="flexContainerRow">
						<Select
							prompt="Position"
							currentVal={this._getPositionId()}
							options={this.props.positions.reduce((acc, elem, ind) => {
								acc[ind] = {
									id: ind,
									name: elem.toUpperCase(),
								};
								return acc;
							}, {})}
							optionsById={Array.from({ length: this.props.positions.length }, (v, i) => i)}
							onChange={this.onPositionChange}
						/>
					</div>
				) : (
					<div className="flexContainerRow">
						<div className="meta-item">Position:</div>
						<div className="meta-item-large">
							{this.props.playerReport.onChange.position.toUpperCase()}
						</div>
					</div>
				)}

				{!this.props.playerReport.readOnly ? (
					<div className="flexContainerRow">
						<div className="meta-item meta-detail">
							<Select
								prompt="Cards"
								currentVal={
									typeof this.state.cards[this.props.cardValue] === 'undefined'
										? ''
										: this.state.cards[this.props.cardValue].id
								}
								options={this.state.cards}
								optionsById={this.state.cardsById}
								onChange={this.onCardChange}
							/>
						</div>
					</div>
				) : (
					<div className="flexContainerRow">
						<div className="meta-item">
							{this.state.cards[this.props.cardValue].name === 'None' ? '' : 'Cards:'}
						</div>
						<div className="meta-item-large display">{this.props.cards}</div>
					</div>
				)}
				{!this.props.playerReport.readOnly ? (
					<div className="flexContainerRow">
						<div className="meta-item">
							<Select
								prompt="Goals"
								currentVal={this.props.goalValue}
								options={this.state.goals}
								optionsById={this.state.goalsById}
								onChange={this.onGoalChange}
							/>
						</div>
					</div>
				) : (
					<div className="flexContainerRow">
						<div className="meta-item">
							{this.state.goals[this.props.goalValue].name === 0 ? '' : 'Goals:'}
						</div>
						<div className="meta-item-large displayGoal">{this.props.goals}</div>
					</div>
				)}
			</div>
		);
	}
}

export { PlayerMeta };



// WEBPACK FOOTER //
// ./src/components/cards/playerMeta/PlayerMeta.js